// extracted by mini-css-extract-plugin
module.exports = {"socialShareButtons":"_17250fa","shareText":"_8fefaf6","shareButton":"_a372eed","email":"_280e27b"};